/* eslint-disable max-len */
import React from 'react';
function SaveAs() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M19.3,10c2.6,0.2,4.6,2.3,4.6,5c0,2.8-2.2,5-5,5h-3v-2h3c1.7,0,3-1.4,3-3c0-1.6-1.2-2.9-2.8-3l-1.5-0.1 l-0.3-1.5C16.9,7.9,14.6,6,12,6C9.9,6,8.1,7.1,7.1,9L6.6,9.9L5.6,10c-2,0.2-3.6,1.9-3.6,4c0,2.2,1.8,4,4,4h2v2H6c-3.3,0-6-2.7-6-6 c0-3.1,2.3-5.6,5.3-6C6.6,5.6,9.1,4,12,4C15.6,4,18.7,6.6,19.3,10z M13,13h3v2h-3v3h-2v-3H8v-2h3v-3h2V13z" })));
}
export default SaveAs;
